import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  forwardRef
} from "@angular/core";
import { fromEvent as observableFromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { TransferListComponent } from "./transfer-list.component";
import { TransferOptionsListComponent } from "./transfer-options-list.component";

@Component({
  selector: "ta-available-options-list",
  templateUrl: "./transfer-options-list.template.html",
  providers: [
    {
      provide: TransferOptionsListComponent,
      useExisting: forwardRef(() => AvailableOptionsListComponent)
    }
  ]
})
export class AvailableOptionsListComponent<Model>
  extends TransferOptionsListComponent<Model>
  implements OnInit
{
  showLoadingIndicator: boolean = true;

  constructor(
    @Inject(forwardRef(() => TransferListComponent))
    public parent: any,
    renderer: Renderer2,
    elementRef: ElementRef
  ) {
    super(parent, renderer, elementRef);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setHostClasses();
  }

  toggleSelectedOptions(): void {
    this.parent.transferToSelected();
  }

  protected setHostClasses(): void {
    super.setHostClasses();
    this.renderer.addClass(
      this.elementRef.nativeElement,
      this.selectClasses.optionsListAvailable
    );
  }

  protected initOptionsSubscription(): void {
    this.optionsSubscription = this.parent.availableOptions.subscribe(
      (newOptions) => {
        this.options = newOptions;
      }
    );
  }

  protected initQueryInputSubscription(): void {
    if (this.queryInput) {
      this.queryInputSubscription = observableFromEvent(
        this.queryInput.nativeElement,
        "input"
      )
        .pipe(debounceTime(300))
        .subscribe(() => {
          this.initializeFocusedOption = true;
          this.parent.queryString.next(this.queryString);
        });
    }
  }
}
